import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { NavigationExtras } from '@angular/router';
import { ModalController, NavController, PopoverController, ToastController } from '@ionic/angular';
import { 
  AuthService, 
  ViewService, ViewService as View,
} from 'common-lib';
import { VirtualScrollerComponent } from 'ngx-virtual-scroller';
import { TrackerAdmin } from 'src/classes/trackerAdmin';
import {ApiService} from "../../services/api.service";
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DataService } from 'src/services/data.service';
import Activity from 'src/classes/activity';
import Company from 'src/classes/company';
import { ListParsers } from 'src/classes/listParsers';

// import * as lodash from 'lodash';

@Component({
  selector: 'app-company-edit',
  templateUrl: './company-edit.page.html',
  styleUrls: ['./company-edit.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompanyEditPage implements OnInit {
  
  cols = [
    {
      css: "text-nowrap",
      prop: "label",
      label: "Azienda",
      cellContentTd: "",
      isAscending: true,
    },
    {
      prop: "idAdmin",
      label: "Agente",
      cellContentTd: "select",
      outputOptions: DataService.array.admin,
      outputOpt_labelProp: "nickname",
      outputOpt_valueProp: "_id",
      pipe_sortAlphabetically_crescent: true,
    },
    {
      prop: "platform_type",
      label: "Piattaforma",
      cellContentTd: "select",
      outputOptions: DataService.platforms,
      outputOpt_labelProp: "name",
      outputOpt_valueProp: "type",
    },
  ];
  
  // Data passed in by componentProps
  @Input() row: Company;

  listener = {
    data: null,
    view: null,
  };
  
  constructor(
    private cd: ChangeDetectorRef,
    private api: ApiService,
    private data: DataService,
    private modalCtrl: ModalController,
    private auth: AuthService,
    private nav: NavController,
    public popoverController: PopoverController,
    private route: ActivatedRoute,
    private router: Router,
    private toastCtrl: ToastController,
    private view: ViewService,
  ) { }

  ngOnInit() {}
  
  // ionViewDidEnter() {
  //   // this.listenerData();
  //   this.listenerView();
  //   // this.data.getEntityMultiple(this.entity as any);
  //   // this.initSomeDOMelems();
  //   console.log("this.row",this.row)
  // }
  //
  // ionViewWillLeave() {
  //   if (this.listener.view) {
  //     this.listener.view.unsubscribe();
  //   }
  // }
  //
  // // * content
  //
  // //  for tests
  // consoleLog(i) {
  //   console.log('i', i)
  //   // console.log('i', DataService.array.activity)
  //   // this.router.navigate(['phonebook-activities']);
  // }
  //
  // dismiss(data?: any) {
  //   // using the injected ModalController this page
  //   // can "dismiss" itself and optionally pass back data
  //   this.modalCtrl.dismiss(data);
  // }
  //
  // async presentToast(msg: string) {
  //   const toast = await this.toastCtrl.create({
  //     message: msg,
  //     duration: 2000,
  //     // position: "middle",
  //   });
  //   toast.present();
  // }
  //
  // async save() {
  //   await this.view.showLoading("salvataggio in corso")
  //   View.updateView.next()
  //
  //   let res: any;
  //   try {
  //     if (!this.row.label) {
  //       throw ({
  //         custom: true,
  //         fieldLbl: "Azienda",
  //         text: "obbligatorio",
  //       });
  //     }
  //
  //     // res = await this.api.patchCompany(this.row);
  //     res = await this.api.patchCompany({
  //       _id: this.row._id,
  //       label: this.row.label,
  //       idAdmin: this.row.idAdmin,
  //       platform_type: this.row.platform_type,
  //       // : this.row.,
  //     });
  //     console.log("save() res", res)
  //
  //     let foundElemIndex: number = DataService.array.company.findIndex(
  //       (el) => el._id === this.row._id
  //     );
  //     // console.log("foundElemIndex",foundElemIndex);
  //     if (foundElemIndex != -1) {
  //       // edit
  //       // DataService.array.company[foundElemIndex] = this.row;
  //       // DataService.array.company[foundElemIndex] = new Company(res, {
  //       //   getAdmin: this.data.getAdminById,
  //       // });
  //       DataService.array.company[foundElemIndex].setAllFields(res);
  //       this.presentToast("Salvataggio avvenuto")
  //       this.dismiss({ recordEdited: true });
  //     }
  //   } catch (e) {
  //     console.error(e);
  //     const { custom, error } = e;
  //
  //     if (custom) {
  //       await this.view.modalAlert(
  //         "Errore salvataggio",
  //         `
  //         Campo '${e.fieldLbl}' ${e.text}
  //         `,
  //         "", // icon
  //         ["Ok"],
  //       );
  //     } else {
  //       await this.view.modalAlert(
  //         "Errore salvataggio",
  //         `
  //         Tipo: ${error.type}, \n
  //         Descrizione: ${error.description}
  //         `,
  //         "", // icon
  //         ["Ok"],
  //       );
  //     }
  //
  //     View.updateView.next()
  //   }
  //
  //   await this.view.hideLoading()
  //   View.updateView.next()
  // }
  //
  // // * listener
  //
  // listenerView() {
  //   this.listener.view = ViewService.updateView$.subscribe((obj?: any) => {
  //     this.view.pipeChanged++;
  //     this.cd.markForCheck();
  //     setTimeout(() => {
  //       this.cd.markForCheck();
  //     }, 250);
  //   });
  // }
  //
  // // * table methods
  //
  // // unused
  // /* parseDatePickerOutput(row: any, prop: string, ISOString: string) {
  //   console.log("parseDatePickerOutput() date", ISOString)
  //   row[prop] = (new Date(ISOString).getTime()) / 1000;
  //
  //   setTimeout(() => {
  //     console.log("timeout row", row)
  //   }, 250)
  //   // View.updateView.next()
  // } */
  //
  // tableRowClick(row) {
  //   console.log('tableRowClick()', row);
  //   // this.rowClick.emit(row);
  //
  //   // switch (this.model) {
  //   //   case "company":
  //   //     this.router.navigate(['phonebook-activities']);
  //   //     break;
  //
  //   //   default:
  //   //     break;
  //   // }
  // }
  // tableRowTd_btnAction(row) {
  //   console.log('row', row);
  // }
  // tableRowTd_radioClick(row) {
  //   console.log('row', row);
  // }
  //
  // tableRowTd_selectChanged(row) {
  //   console.log('row', row);
  // }
  // // unused
  // /* tableRowTd_selectChanged_v1(
  //   row: any, prop: string, option_valueProp: string | number,
  //   valPropBool?: boolean
  // ) {
  //   // console.log("prop", prop)
  //   console.log("option_valueProp", option_valueProp)
  //   if (valPropBool) {
  //     const ret: boolean = option_valueProp === "true" ? true : false;
  //     row[prop] = ret;
  //   } else {
  //     row[prop] = option_valueProp;
  //   }
  //
  //   setTimeout(() => {
  //     console.log("timeout row", row)
  //   }, 250)
  //   // View.updateView.next()
  // } */
  //
  // tableRowTh_btnAction(col) {
  //   console.log('col', col);
  // }
  
  

}
